import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackAudioFailedSpec,
  trackAudioStoppedSpec,
  trackAudioUploadedSpec,
  trackAudioWarningAcceptedSpec,
  trackAudioWarningViewedSpec,
  trackLegacyInlineDictationCompletedSpec,
  trackTranscriptionStartedSpec,
  trackTranscriptionStoppedSpec,
  trackUniversalDictationCompletedSpec,
  type AudioFailed,
  type AudioStopped,
  type AudioUploaded,
  type AudioWarningAccepted,
  type AudioWarningViewed,
  type LegacyInlineDictationCompleted,
  type TranscriptionStarted,
  type TranscriptionStopped,
  type UniversalDictationCompleted,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const audioEvents: SnowplowEventMap = {
  [TrackingEventName.AudioUploaded]: (props) =>
    trackAudioUploadedSpec(props as AudioUploaded),
  [TrackingEventName.AudioFailed]: (props) => trackAudioFailedSpec(props as AudioFailed),
  [TrackingEventName.AudioStopped]: (props) =>
    trackAudioStoppedSpec(props as AudioStopped),
  [TrackingEventName.TranscriptionStarted]: (props) =>
    trackTranscriptionStartedSpec(props as TranscriptionStarted),
  [TrackingEventName.TranscriptionStopped]: (props) =>
    trackTranscriptionStoppedSpec(props as TranscriptionStopped),
  [TrackingEventName.DictationCompleted]: (props) =>
    trackUniversalDictationCompletedSpec(props as UniversalDictationCompleted),
  [TrackingEventName.LegacyInlineDictationCompleted]: (props) =>
    trackLegacyInlineDictationCompletedSpec(props as LegacyInlineDictationCompleted),
  // APP-7915 WS4/WS5 warning funnel — dispatched only via the
  // `audioWarningViewed` / `audioWarningAccepted` model helpers (amplitude:false).
  [TrackingEventName.AudioWarningViewed]: (props) =>
    trackAudioWarningViewedSpec(props as AudioWarningViewed),
  [TrackingEventName.AudioWarningAccepted]: (props) =>
    trackAudioWarningAcceptedSpec(props as AudioWarningAccepted),
  // GRO-3186: `transcription_skipped` is a new event. Snowplow routing is
  // intentionally omitted until the Iglu schema lands in `@snowtype/snowplow`;
  // until then the event still flows to Amplitude and Datadog via the default
  // `trackEventV2` destinations. Add the spec wiring once the schema is
  // published.
};
